import * as React from 'react';
import { SVGProps } from 'react';
import { withForgeIconProps } from './ForgeIconProps';
interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgModalPopupSmall = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps): JSX.Element => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="fi_c_icon"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M13 10.8701V12C13 12.7956 12.6839 13.5587 12.1213 14.1213C11.5587 14.6839 10.7956 15 10 15H1V3H5M5 1H15V8C15 8.79565 14.6839 9.55873 14.1213 10.1213C13.5587 10.6839 12.7956 11 12 11H5V1Z"
      stroke={props.color}
      strokeWidth={2}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
  </svg>
);

SvgModalPopupSmall.displayName = 'SvgModalPopupSmall';
const ModalPopupSmall = withForgeIconProps(SvgModalPopupSmall, {
  name: 'ModalPopup',
  usage: 'Use to open a Modal.',
  related: 'popover',
  isLabelRequired: true,
  isNeutralInteractive: false,
  size: 'small',
});
export default ModalPopupSmall;
